import { useMemo } from "react";

import deepmerge from "deepmerge";
import { SeriesClickEventObject } from "highcharts";
import { useIntl } from "react-intl";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import ActivityTypeWithCount from "@mapmycustomers/shared/types/entity/activities/ActivityTypeWithCount";

const useActivityTypesChartConfig = (
  actitivityTypesWithCount: ActivityTypeWithCount[],
  defaultConfig: object,
  onActivityTypeClick: (type: ActivityType) => void
) => {
  const intl = useIntl();
  return useMemo(() => {
    const filteredActivityTypes = actitivityTypesWithCount.filter(({ count }) => count > 0);
    return deepmerge.all([
      {},
      defaultConfig,
      {
        series: [
          {
            colorByPoint: true,
            data: filteredActivityTypes.map(({ count, name }) => [name, count]),
            events: {
              click: (event: SeriesClickEventObject) => {
                const selectedActivityType = actitivityTypesWithCount.find(
                  (type) => type.name === event.point.name
                );
                if (selectedActivityType) {
                  onActivityTypeClick(selectedActivityType);
                }
              },
            },
            name: intl.formatMessage({
              id: "home.cards.activityTypes.chartConfig.series.name",
              defaultMessage: "Activity Types",
              description: "Activity Types for Chart series in chart Config",
            }),
          },
        ],
        xAxis: {
          categories: filteredActivityTypes.map(({ name }) => name),
        },
      },
    ]);
  }, [actitivityTypesWithCount, defaultConfig, intl, onActivityTypeClick]);
};

export default useActivityTypesChartConfig;
